// useTranslation.ts
import { useState, useEffect, useCallback } from 'react';
import { translations, TranslationKey, Language, getLanguage } from './translations';

export function useTranslation() {
  const [language, setLanguage] = useState<Language>(getLanguage);

  useEffect(() => {
    // Listen for language changes from index.html
    const handleLanguageChange = (event: CustomEvent<{ language: Language }>) => {
      setLanguage(event.detail.language);
    };

    window.addEventListener('languageChanged', handleLanguageChange as EventListener);

    // Also check periodically in case window.xyzCurrentLanguage changes
    const interval = setInterval(() => {
      const currentLang = getLanguage();
      if (currentLang !== language) {
        setLanguage(currentLang);
      }
    }, 500);

    return () => {
      window.removeEventListener('languageChanged', handleLanguageChange as EventListener);
      clearInterval(interval);
    };
  }, [language]);

  const t = useCallback((key: TranslationKey): string => {
    return translations[key]?.[language] || translations[key]?.['en'] || key;
  }, [language]);

  return { t, language };
}
